/* oxlint-disable */
import { exception } from '@/utils/exception';

export async function launchGame(gameData: any) {
  try {
    const response = await fetch('/api/casino/games/play', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ gameData }),
      credentials: 'include',
    });
    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage = errorData.message || 'Failed to launch game';

      if (response.status === 401) {
        return { message: 'Necsitas iniciar sesion para jugar', login: true };
      }

      throw new Error(errorMessage);
    }

    const data = await response.json();
    return data;
  } catch (error: any) {
    throw new Error(error.message || 'An error occurred while launching the game');
  }
}

export async function updateFavoriteGames(favorites: string[]) {
  try {
    const res = await fetch('/api/casino/games/favorites', {
      method: 'PATCH',
      body: JSON.stringify({ favorites }),
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-store',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      return favorites;
    }

    const data = await res.json();
    return Array.isArray(data.favoriteGames) ? data.favoriteGames : favorites;
  } catch (error) {
    await exception(error, { route: '/features/casino/services/index.ts: updateFavoriteGames', method: 'PATCH', req: favorites });
    return favorites;
  }
}
